/**
 * Choose the correct backend url by looking at the user's hostname
 *
 * @return {string} backend url
 */
export default function domain() {
  if (window.location.hostname === "apps.filtpod.com" || window.location.hostname === "apps.engage-ai.co") {
    return "https://server1.engage-ai.co/";
  } else if (
    window.location.hostname === "filtpod-frontend-test.web.app" ||
    window.location.hostname === "filtpod-frontend-test.firebaseapp.com"
  ) {
    return "https://server1.engage-ai.co/";
  } else {
    // FIX: Check for an environment variable. If it doesn't exist, THEN use localhost.
    return process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/";
  }
}
